import { render, staticRenderFns } from "./Acompanhamentos.vue?vue&type=template&id=fc5ba7e6&scoped=true"
import script from "./Acompanhamentos.vue?vue&type=script&lang=js"
export * from "./Acompanhamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5ba7e6",
  null
  
)

export default component.exports